import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AnnouncementBar from '../components/AnnouncementBar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BestSellingSpices from '../components/BestSellingSpices';

export default function CollectionPage() {
  const { category } = useParams();
  const navigate = useNavigate();
  const title = {
    all: 'All Spices',
    whole: 'Whole Spices',
    ground: 'Ground Spices',
    blends: 'Masala Blends',
  }[category] || 'All Spices';

  return (
    <>
      <AnnouncementBar />
      <Header />
      <div className="hero-radial py-10 md:py-14">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 text-center">
          <div className="text-xs tracking-[0.3em] uppercase font-semibold mb-2" style={{ color: 'var(--gk-gold-dark)' }}>• Collection •</div>
          <h1 className="font-serif text-4xl md:text-5xl font-bold" style={{ color: 'var(--gk-green-dark)' }}>{title}</h1>
          <p className="mt-3 text-sm md:text-base max-w-2xl mx-auto" style={{ color: 'var(--gk-muted)' }}>Freshly milled small-batch spices, sourced from farms we know by name.</p>
        </div>
      </div>
      <BestSellingSpices defaultCategory={category || 'all'} hideTitle />
      <Footer />
    </>
  );
}
